// Generated by spriteMerger.js
import { ComponentProps } from 'react';
import Icon from '../Icon';
import content from './content.svg';

interface ContentIconProps extends Omit<ComponentProps<typeof Icon>, 'link'> {
  name: ContentNames;
}

export function ContentIcon({ name, ...props }: ContentIconProps) {
  return <Icon {...props} link={content} name={name} />
}

type ContentNames =
  | 'add_box'
  | 'add_circle_outline'
  | 'add_circle'
  | 'add_link'
  | 'archive'
  | 'attribution'
  | 'backspace'
  | 'ballot'
  | 'biotech'
  | 'block'
  | 'bolt'
  | 'calculate'
  | 'change_circle'
  | 'clear'
  | 'content_copy'
  | 'content_cut'
  | 'content_paste_go'
  | 'content_paste_off'
  | 'content_paste_search'
  | 'content_paste'
  | 'copy_all'
  | 'create'
  | 'delete_sweep'
  | 'deselect'
  | 'drafts'
  | 'dynamic_feed'
  | 'file_copy'
  | 'filter_list_off'
  | 'filter_list'
  | 'flag_circle'
  | 'flag'
  | 'font_download_off'
  | 'font_download'
  | 'forward'
  | 'gesture'
  | 'how_to_reg'
  | 'how_to_vote'
  | 'inbox'
  | 'insights'
  | 'inventory_2'
  | 'inventory'
  | 'link_off'
  | 'link'
  | 'low_priority'
  | 'mail'
  | 'markunread'
  | 'move_to_inbox'
  | 'next_week'
  | 'outlined_flag'
  | 'policy'
  | 'push_pin'
  | 'redo'
  | 'remove_circle_outline'
  | 'remove_circle'
  | 'remove'
  | 'reply_all'
  | 'reply'
  | 'report_gmailerrorred'
  | 'report_off'
  | 'report'
  | 'save_alt'
  | 'save_as'
  | 'save'
  | 'select_all'
  | 'shield'
  | 'sort'
  | 'square_foot'
  | 'stacked_bar_chart'
  | 'stream'
  | 'tag'
  | 'text_format'
  | 'unarchive'
  | 'undo'
  | 'upcoming'
  | 'waves'
  | 'weekend'
  | 'where_to_vote'
;

